window.Vendallion = window.Vendallion || {};
Vendallion.Select = {};

Vendallion.Select.Init = (selectEl) => {
    if (selectEl) {
        handleSelect(selectEl);
    } else {
        const selectElements = document.querySelectorAll('[data-vd-component="select"]');
        if (selectElements.length == 0) return;

        selectElements.forEach((selectEl) => {
            handleSelect(selectEl);
        });
    }

    function handleSelect(selectEl) {
        if (selectEl.__vdSelectInitialized) return;

        const trigger = selectEl.querySelector(".trigger");
        if (!trigger) return;

        const label = trigger.querySelector(".label");
        const chevron = trigger.querySelector(".chevron");
        const optionsContainer = selectEl.querySelector(".options");
        if (!label || !chevron || !optionsContainer) return;

        const options = Array.from(optionsContainer.querySelectorAll("li"));
        const originalSelect = selectEl.querySelector("select");
        let suppressOpenOnFocus = false;
        selectEl.__vdSelectInitialized = true;

        options.forEach((option) => {
            option.setAttribute("tabindex", "-1");
        });

        function isOpen() {
            return !optionsContainer.classList.contains("hidden");
        }

        function openDropdown() {
            chevron.classList.add("rotate-180");
            optionsContainer.classList.remove("hidden");
        }

        function closeDropdown() {
            chevron.classList.remove("rotate-180");
            optionsContainer.classList.add("hidden");
        }

        function focusTriggerWithoutOpening() {
            suppressOpenOnFocus = true;
            trigger.focus();
        }

        function applySelection(value, shouldFocusOption = false) {
            selectEl.select(value);

            const selectedOption = options.find((opt) => opt.getAttribute("data-value") === value);
            options.forEach((opt) => {
                opt.classList.toggle("selected", opt === selectedOption);
            });

            if (shouldFocusOption && selectedOption) {
                selectedOption.focus();
            }

            if (!originalSelect) return;

            const originalOptions = originalSelect.querySelectorAll("option");
            originalOptions.forEach((opt) => {
                opt.selected = opt.value === value;
                if (opt.value === value) {
                    opt.setAttribute("selected", "selected");
                } else {
                    opt.removeAttribute("selected");
                }
            });

            originalSelect.dispatchEvent(new Event("change"));
        }

        function moveSelection(step) {
            if (options.length === 0) return;

            if (!isOpen()) {
                openDropdown();
            }

            const currentIndex = getSelectedIndex();
            const baseIndex = currentIndex === -1 ? (step > 0 ? -1 : 0) : currentIndex;
            const nextIndex = (baseIndex + step + options.length) % options.length;
            const value = options[nextIndex].getAttribute("data-value");

            if (value != null) {
                applySelection(value, true);
            }
        }

        function handleKeyboard(event) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                moveSelection(1);
                return;
            }

            if (event.key === "ArrowUp") {
                event.preventDefault();
                moveSelection(-1);
                return;
            }

            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                if (isOpen()) {
                    closeDropdown();
                    focusTriggerWithoutOpening();
                } else {
                    openDropdown();
                }
                return;
            }

            if (event.key === "Escape") {
                selectEl.close();
                focusTriggerWithoutOpening();
            }
        }

        function getSelectedIndex() {
            const selectedValue = selectEl.getAttribute("data-selected") || originalSelect?.value;
            return options.findIndex((opt) => opt.getAttribute("data-value") === selectedValue);
        }

        // Make the custom trigger reachable with keyboard Tab navigation.
        if (!trigger.hasAttribute("tabindex")) {
            trigger.setAttribute("tabindex", "0");
        }

        selectEl.placeholder = label.textContent;

        selectEl.close = function () {
            closeDropdown();
        };

        selectEl.reset = function () {
            label.textContent = selectEl.placeholder;
            selectEl.removeAttribute("data-selected");
            originalSelect && (originalSelect.value = null);
        };

        selectEl.select = function (value) {
            const option = options.find((opt) => opt.getAttribute("data-value") === value);
            if (!option) return;

            label.textContent = option.textContent;
            selectEl.setAttribute("data-selected", value);
            originalSelect && (originalSelect.value = value);
        };

        trigger.addEventListener("click", () => {
            if (isOpen()) {
                closeDropdown();
                return;
            }

            openDropdown();
        });

        trigger.addEventListener("focus", () => {
            if (suppressOpenOnFocus) {
                suppressOpenOnFocus = false;
            }
        });

        trigger.addEventListener("keydown", handleKeyboard);

        options.forEach((option) => {
            option.addEventListener("keydown", handleKeyboard);

            option.addEventListener("click", () => {
                const value = option.getAttribute("data-value");
                applySelection(value, true);
                selectEl.close();
                focusTriggerWithoutOpening();

                // Dispatch a custom event to notify about the change
                const event = new CustomEvent("selectChange", {
                    detail: { value: value, label: option.textContent },
                });
                selectEl.dispatchEvent(event);
            });
        });

        selectEl.addEventListener("focusout", () => {
            // Close when focus leaves the custom select (trigger or options).
            setTimeout(() => {
                if (!selectEl.contains(document.activeElement)) {
                    closeDropdown();
                }
            }, 0);
        });

        document.addEventListener("click", (event) => {
            if (!selectEl.contains(event.target)) {
                selectEl.close();
            }
        });
    }
};

Vendallion.Select.Init();
